import { Component } from '@angular/core';
import { ModelService } from '../../Services/model.service';
import { FtpServer } from '../../Model/FtpServer';
import { Catalog } from '../../Model/Catalog/Catalog';
import { CatalogService } from '../../Services/CatalogManagement/catalog.service';
import { lastValueFrom } from 'rxjs';
import { Message } from '../../Model/System/Message';
import { FtpServerService } from '../../Services/ftp/ftpServer.service';
import { MediaFtpExportSettingsService } from '../../Services/ftp/mediaFtpExportSettings.service';
import { MediaFtpExportSettings } from '../../Model/recurringJobs/ftp/mediaFtpExportSettings';
import { InitNewRowEvent, RowInsertedEvent, RowRemovedEvent, RowUpdatedEvent } from 'devextreme/ui/data_grid';

@Component({
    selector: 'mediaFtpExport',
    templateUrl: 'mediaFtpExport.component.html',
    standalone: false
})
export class MediaFtpExportComponent {
  catalogs: Catalog[] = [];
  ftpServers: FtpServer[] = [];

  mediaFtpExportSettings: MediaFtpExportSettings[] = [];

  constructor(
    public modelService: ModelService,
    public mediaFtpExportSettingsService: MediaFtpExportSettingsService,
    public ftpServerService: FtpServerService,
    public catalogService: CatalogService
  ) {
    this.loadSettings = this.loadSettings.bind(this);
    this.addSetting = this.addSetting.bind(this);
    this.updateSetting = this.updateSetting.bind(this);
    this.deleteSetting = this.deleteSetting.bind(this);
    this.run = this.run.bind(this);
    this.onRowRemoved = this.onRowRemoved.bind(this);
    this.onRowUpdated = this.onRowUpdated.bind(this);
    this.onRowInserted = this.onRowInserted.bind(this);

    this.loadSettings();

    this.ftpServerService.getAllServer().subscribe((ftpServer: FtpServer[]) => {
      this.ftpServers = ftpServer;
    });
    this.catalogService
      .getCatalogs(this.modelService.loginService.currentCustomer.id)
      .subscribe((catalogs: Catalog[]) => {
        this.catalogs = catalogs;
      });
  }

  async loadSettings() {
    this.mediaFtpExportSettings = await lastValueFrom(this.mediaFtpExportSettingsService.getAll());
    this.mediaFtpExportSettings.forEach((f: MediaFtpExportSettings) => {
      f.time = new Date(f.time);
    });
  }

  async onInitNewRow(event: InitNewRowEvent<MediaFtpExportSettings>) {
    event.data.active = true;
  }

  async addSetting(setting: MediaFtpExportSettings) {
    setting.id = (await lastValueFrom(this.mediaFtpExportSettingsService.create(setting))).id;
  }

  async updateSetting(setting: MediaFtpExportSettings) {
    await lastValueFrom(this.mediaFtpExportSettingsService.update(setting));
  }

  async deleteSetting(setting: MediaFtpExportSettings) {
    await lastValueFrom(this.mediaFtpExportSettingsService.delete(setting.id));
  }

  async onRowInserted(event: RowInsertedEvent<MediaFtpExportSettings>) {
    var setting = event.data;
    await this.addSetting(setting);
  }

  async onRowUpdated(event: RowUpdatedEvent<MediaFtpExportSettings>) {
    var setting = event.data;
    await this.updateSetting(setting);
  }

  async onRowRemoved(event: RowRemovedEvent<MediaFtpExportSettings>) {
    var setting = event.data;
    await this.deleteSetting(setting);
  }

  isManager(): boolean {
    if (
      this.modelService.loginService.currentUser.currentClaim == 'MANAGER' ||
      this.modelService.loginService.currentUser.currentClaim == 'ADMIN'
    )
      return true;
    return false;
  }

  getLastRun(rowData): string {
    if (rowData.lastRun instanceof String) rowData.lastRun = new Date(rowData.lastRun);

    return rowData.lastRun;
  }

  run(d) {
    this.mediaFtpExportSettingsService.run(d.id).subscribe(
      () => {
        this.modelService.systemService.notify(new Message('Export Job wurde gestartet.'));
      },
      (error) => {
        let msg = new Message();
        msg.type = 'Error';
        msg.message = 'Fehler beim manuellen starten';
        this.modelService.systemService.notify(msg);
      }
    );
  }
}
